import { render, staticRenderFns } from "./BundleCard.vue?vue&type=template&id=57db39aa&scoped=true"
import script from "./BundleCard.vue?vue&type=script&lang=js"
export * from "./BundleCard.vue?vue&type=script&lang=js"
import style0 from "./BundleCard.vue?vue&type=style&index=0&id=57db39aa&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57db39aa",
  null
  
)

export default component.exports